/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Explorer_Display_Delete_Success_ToastInputs */

const en_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} record(s) deleted successfully`)
};

const fr_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} enregistrement(s) supprime(s) avec succes`)
};

const de_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Datensatz(e) erfolgreich gelöscht`)
};

const it_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} record eliminati con successo`)
};

const ru_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запись(и) ${i?.count} успешно удалена(ы).`)
};

const es_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} registro(s) eliminado(s) exitosamente`)
};

const zh_cn2_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 记录已成功删除`)
};

const ja_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件のレコードが正常に削除されました`)
};

const hi_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} रिकॉर्ड सफलतापूर्वक हटा दिए गए`)
};

const pt_pt2_explorer_display_delete_success_toast = /** @type {(inputs: Explorer_Display_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registro(s) ${i?.count} excluído(s) com sucesso`)
};

/**
* | output |
* | --- |
* | "{count} record(s) deleted successfully" |
*
* @param {Explorer_Display_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_success_toast = /** @type {((inputs: Explorer_Display_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_delete_success_toast(inputs)
	if (locale === "de") return de_explorer_display_delete_success_toast(inputs)
	if (locale === "it") return it_explorer_display_delete_success_toast(inputs)
	if (locale === "ru") return ru_explorer_display_delete_success_toast(inputs)
	if (locale === "es") return es_explorer_display_delete_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_delete_success_toast(inputs)
	if (locale === "ja") return ja_explorer_display_delete_success_toast(inputs)
	if (locale === "hi") return hi_explorer_display_delete_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_delete_success_toast(inputs)
	return en_explorer_display_delete_success_toast(inputs)
});